<template>
  <div class="p-30">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="handleLoadMore"
    >
      <div v-for="(v, i) in listData" :key="i" class="m-b-30 coupon_list_item">
        <div class="coupon_list_left">
          <div class="left_con p-lr-36 f-cl">
            <div>
              <span class="c-ft-32">{{ v.TicketName }}</span>
            </div>
            <div class="m-b-10 c-ft-24" :style="{ color: '#999' }">
              <span>有效期: </span>
              <span>{{ v.UseStartDate }} 至 {{ v.UseEndDate }}</span>
            </div>
            <div v-if="v.TicketStatus.Id == 1 && v.CanBeGift">
              <van-button
                round
                color="var(--tc)"
                size="mini"
                @click.stop="handleSendTicket(v)"
                >赠送给朋友</van-button
              >
            </div>
            <!-- <div>
              <span class="c-ft-20 coupon_rule_btn" @click.stop="lookDetail(v)"
                >使用规则</span
              >
            </div> -->
          </div>
        </div>

        <div
          class="right_con p-lr-10 p-tb-24 c-fc-center h-block"
          :style="{
            'justify-content': v.Price > 0 ? 'space-between' : 'center',
          }"
        >
          <div class="" v-if="v.Price > 0">
            <div class="money">
              <span>￥</span>
              <span>{{ v.Price }}</span>
            </div>
            <!-- <div class="c-ft-24">{{ v.UseLimit || "" }}</div> -->
          </div>

          <div>
            <span v-if="v.IsCanFrontdeskUse">
              <van-button
                round
                color="var(--tc)"
                size="small"
                @click="handleShowUseCode(v)"
                :disabled="v.TicketStatus.Id != 1"
                >{{
                  v.TicketStatus.Id == 1 ? "去使用" : v.TicketStatus.Name
                }}</van-button
              >
            </span>
            <span v-else class="c-ft-26 c-lightgrey">仅支持线上结算</span>
          </div>
        </div>
      </div>
    </van-list>

    <!-- <van-dialog
      title="票券码"
      v-model="showQr"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
    >
      <div class="p-26 c-fc-center">
        <div class="code_con">
          <vue-qr :text="qrCode" class="qr_code"></vue-qr>
        </div>
        <p>结账时请向收银员出示此码</p>
      </div>
    </van-dialog> -->
    <van-overlay :show="showQr" z-index="5">
      <div class="overlay_con">
        <div class="code_con">
          <p class="m-tb-20 code_title">票券码</p>
          <div class="codeImage" v-show="qrCode">
            <vue-qr :text="qrCode" class="qr_code"></vue-qr>
            <!-- <img :src="electronicImage" alt=""> -->
          </div>
          <div>{{ qrCode }}</div>
          <p class="m-t-20 m-b-60 c-lightgrey">结账时向收银员出示此码</p>
          <!-- <p class="c-orange code_tip">生成一次性支付码给好友</p> -->
          <van-icon
            name="close"
            class="close_btn_con"
            color="#fff"
            size="30"
            @click="hideModel"
          />
        </div>
      </div>
    </van-overlay>
    <van-dialog
      title="使用规则"
      v-model="showRule"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
    >
      <div class="p-26 h-300">
        <ul class="rules_con" v-if="couponLimit.length > 0">
          <li v-for="(item, index) in couponLimit" :key="index">
            <span v-if="item.TypeName"> {{ item.TypeName }}: </span>
            <span>
              <a v-for="(items, indexs) in item.GroupDetail" :key="indexs">
                {{ items }}
              </a>
            </span>
          </li>
        </ul>
        <gNoContent v-else title="暂无规则" widthData="160"></gNoContent>
      </div>
    </van-dialog>
    <shareOverlay
      ref="shareOverlayRef"
      @handleGetList="handleGetList"
    ></shareOverlay>
  </div>
</template>

<script>
// import {receiveCoupon} from '@/api/coupon'
import { Toast } from "vant";
import { getUserCouponList, transferMyTicket } from "@/api/coupon";
import wxConfig from "@/utils/wxConfig.js";
import shareOverlay from "@/components/shareOverlay/index.vue";
export default {
  name: "CouponsListCom",
  // props: {
  //   listData: {
  //     type: Array,
  //     default: () => {
  //       return [];
  //     },
  //   },
  // },
  data() {
    return {
      listData: [],
      nowPageIndex: 0,
      allPage: 0,
      loading: false,
      finished: false,
      showRule: false,
      showQr: false,
      qrCode: "",
      couponLimit: [],
    };
  },
  components: { shareOverlay },

  mounted() {},

  created() {},
  methods: {
    // 获取优惠券列表
    handleGetDiscountCoupon(flag) {
      // let params = {
      //   Type: 'All',
      //   Status: '未使用',
      //   GoodsType: 'coupon',
      //   ExcludeQRcode: true
      // }
      // this.$http('discountticket/couponlist', params, 'post').then(res => {
      //   this.tableList[0].label = `${res.length}张 优惠券可用`
      getUserCouponList({
        query: { IsCoupon: true, Status: 1, VpnId: this.$store.state.vpnId },
        pager: { pageindex: this.nowPageIndex, pagesize: 20 },
      })
        .then((res) => {
          res.Items.forEach((v) => {
            v.UseEndDate = v.UseEndDate.split(" ")[0];
            v.UseStartDate = v.UseStartDate.split(" ")[0];
          });
          this.listData =
            flag == "loadmore" ? this.listData.concat(res.Items) : res.Items;
          this.allPage = res.Pager.TotalPage;
          const allCount = res.Pager.TotalCount;
          if (flag !== "loadmore") {
            this.$emit("setTicketCount", allCount);
          }
          //   // 加载状态结束
          this.loading = false;
          //   // 数据全部加载完成
          if (this.listData.length >= allCount) {
            this.finished = true;
          }
          console.log(this.listData);
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    handleInitGetCouponList() {
      this.nowPageIndex = 0;
      this.handleGetDiscountCoupon();
    },
    handleLoadMore() {
      if (this.nowPageIndex + 1 < this.allPage) {
        this.nowPageIndex++;
        this.handleGetDiscountCoupon("loadmore");
      }
    },
    handleShowUseCode(v) {
      // let id = v.TicketCode;
      // this.$http(`discountticket/qrcode?code=${id}`).then(res => {
      // this.qrCode = 'data:image/png;base64,' + res.CodeDataSrc
      this.qrCode = v.TicketCode;
      this.showQr = true;
      // })
    },
    lookDetail(v) {
      // this.dialogObj = this.$pub.deepClone(v)
      // this.dialogObj.StartDate = this.$pub.parseDate(v.StartDate)
      // this.dialogObj.EndTime = this.$pub.parseDate(v.EndTime)
      // let id = v.TicketCode
      if (v.TicketExplain) {
        const couponArr = JSON.parse(v.TicketExplain);
        this.couponLimit =
          couponArr.length == 1 && !couponArr[0].TypeName ? [] : couponArr;
      }
      // id = id.indexOf(':') ? id.split(':')[1] : id;
      // this.$http(`discountticket/qrcode?code=${id}`).then(res => {
      //   this.qrCode = 'data:image/png;base64,' + res.CodeDataSrc
      //   this.dialogObj.qrCode = 'data:image/png;base64,' + res.CodeDataSrc
      this.showRule = true;
      console.log(8888888);
      // })
    },
    hideModel() {
      this.showQr = false;
      this.showRule = false;
    },
    handleSendTicket(item) {
      let that = this;
      this.$refs.shareOverlayRef.handleSetShowShare();
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
      const imgData = item.Claims.find((imgItem) => imgItem.TypeId == 0);
      transferMyTicket({ TicketCode: item.TicketCode }).then((res) => {
        const sendId = res;
        wxConfig.WeChatShare(
          this,
          window.location.href.split("#/")[0] +
            "#/ReceiveGiftCoupon/" +
            item.Id +
            "/" +
            sendId,
          "送你一张优惠券",
          imgData ? imgData.Value : "",
          "[" + item.TicketName + "]"
        );
      });
    },
    handleGetList() {
      this.handleInitGetCouponList();
    },
  },
};
</script>
<style scoped lang="scss">
.coupon_center_con {
  background: #f3f5f9;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 10px 0;
}
.coupon_list_item {
  position: relative;
  &:last-child {
    margin-bottom: 0 !important;
  }
  .coupon_list_left {
    width: calc(100% - 210px);
    display: flex;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    height: 200px;
    margin: 10px 0;
    box-sizing: border-box;
    background: #fff;
    align-items: center;
    .coupon_rule_btn {
      border-radius: 10px;
      padding: 5px 10px;
      border: 1px solid #dcc494;
      color: #dcc494;
    }
    .img_con {
      width: 150px;
      height: 150px;
      padding-left: 20px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }
}
.left_con {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 150px;
}
.right_con {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  height: 216px;
  width: 250px;
  right: 0;
  top: -9px;
  position: absolute;
  box-sizing: border-box;
  background: url("../../assets/images/coupon-bg.png") no-repeat;
  background-size: cover;

  .money {
    color: #c8465c;
    font-size: 42px;
  }
  .sub-txt {
    font-size: 21px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #c7beb2;
    text-align: center;
  }
}
.rules_con {
  height: 350px;
  overflow: auto;
  li {
    display: flex;
    color: #999;
    margin-bottom: 10px;
    font-size: 30px;
    span {
      &:first-child {
        width: 155px;
        flex-shrink: 0;
      }
      a {
        margin-bottom: 10px;
      }
    }
  }
}
.code_con {
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 26px;
  width: 80vw;
  position: relative;

  .code_title {
    font-size: 30px;
  }
  .qr_code {
    width: 500px;
  }
  .close_btn_con {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
